export const LOCAL = "local";
export const ADMIN = "admin";
export const USER = "user";
export const DRAWER_WIDTH = 240;
export const PRODUCTION = "production";
export const TRANSPARENCY = 0.8;
export const APP_ID =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYiI6ImltdGV4MjAyN19pbXRtYSIsIm5hbWUiOiJJTVRFWCAyMDI3Iiwicm9sZSI6ImFwcCIsImlhdCI6MTc5MTE5MjUzMywiZXhwIjoxODIyNzUwMTMzfQ.nx7iu9eJ9TrhWx916sK93g2nU-1L-6p2CnpeHWBCFyM";
export const state = PRODUCTION;
export const API_ENDPOINT =
  state === PRODUCTION
    ? "https://apis.expoplanner.in" //https://mirrorapis.expoplanner.in/
    : "http://localhost:5002";

export const TimeZoneIndia = {
  timeZone: "Asia/Kolkata", // IST Timezone
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};
export const TimeOnlyZone = {
  timeZone: "Asia/Kolkata",
  hour: "2-digit",
  minute: "2-digit",
};
export const USER_ROLES = {
  SUPER: "super",
  ADMIN: "admin",
  TD_ADMIN: "TD Admin",
  VISITOR: "visitor",
  EXHIBITOR: "exhibitor",
  TEAM: "team",
  TRADE_DELEGATE: "trade_delegate",
  DB: "db",
  OES: "oes",
  SPECIAL_INVITEE: "Special Invitee",
  STUDENT: "STUDENT",
};
export const ONSITE_MODULE_ITEMS = Object.freeze({
  ONSITE_LINK: "ONSITE_LINK",
  ONSITE_REGISTRATION: "ONSITE_REGISTRATION",
  SECURITY_SCANNING: "SECURITY_SCANNING",
  KIOSK_BADGE_PRINTING: "KIOSK_BADGE_PRINTING",
  BULK_PRINTING: "BULK_PRINTING",
  FOOTFALL_ANALYSIS: "FOOTFALL_ANALYSIS",
  SEARCH_AND_PRINT: "SEARCH_AND_PRINT",
  BULK_STUDENT_BADGES: "BULK_STUDENT_BADGES",
  SERVICE_BADGE: "SERVICE_BADGE",
  SERVICE_BADGE_SCAN: "SERVICE_BADGE_SCAN",
  LOCATIONWISE_SECURITY_SCAN: "LOCATIONWISE_SECURITY_SCAN",
  PRINT_STAFF_BADGE: "PRINT_STAFF_BADGE",
});
